<template>
  <div>
    <section class="nav" :class="{ 'navClose': !navShow }">
      <el-button class="btnExpand" :class="{ 'el-icon-menu': navShow, 'el-icon-doubleright': !navShow }"
        @click.native="navChange"></el-button>
      <router-link v-if="item.right" class="link" v-for="item in routeList" :key="item.route"
        :to="{ name: item.route, query: item.query }" style="overflow:hidden;" active-class="active-link">
        <i :class="'fa ' + item.icon" style="width:20px;text-align:center;"></i>
        <span :class="{ 'listName': navShow, 'listNameClose': !navShow }"
          style="letter-spacing:10px;font-weight:500;">{{
            item.name }}</span>
      </router-link>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import iconTypes from "@/metadata/icon-types.js";

export default {
  props: ["navShow"],
  data() {
    return {
      routeActive: 0
    };
  },
  computed: {
    ...mapGetters(["hasPermission"]),
    permissonList() {
      return this.$store.state.permissionList;
    },
    routeList() {
      return [
        {
          name: "项目",
          route: "project",
          right: true,
          icon: iconTypes["project"]
        },
        {
          name: "设备",
          route: "device",
          right: this.hasPermission('device'),
          icon: iconTypes["device"]
        },
        {
          name: "隐患",
          route: "trouble",
          right: this.hasPermission('device'),
          icon: iconTypes["contract"]
        },
        {
          name: "汇总",
          route: "statistics",
          right: this.hasPermission('system'),
          icon: iconTypes["stat"]
        },
        {
          name: "任务",
          route: "task",
          right: this.hasPermission('system'),
          icon: iconTypes["task"]
        },
        {
          name: "模板",
          route: "template",
          right: this.hasPermission('system'),
          icon: iconTypes["report"]
        },
        {
          name: "系统",
          route: "system",
          right: this.hasPermission('system'),
          icon: iconTypes["system"]
        }
      ];
    },
  },
  watch: {
    "$route.name"(val) {
      this.routeActive = val;
      if (val === "home") {
        this.$router.replace({ name: this.routeList[0].route });
      }
    }
  },
  methods: {
    navChange() {
      this.$emit("update:navShow", !this.navShow);
    },
  },
  async created() {
    // 写入路由以及权限列表
    await this.$store.commit("GET_ROUTE_LIST");
    if (this.$route.name === "home") {
      this.$router.push({ name: this.routeList[0].route });
    }
  }
};
</script>
<style scoped lang="scss">
.nav {
  position: fixed;
  display: block;
  left: 0;
  top: 0;
  padding-top: 40px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 8;
  height: 100%;
  width: 140px;
  transition: width 0.5s;
  box-shadow: 5px 0px 12px -3px rgba(221, 222, 225, 0.5);
  background-color: $color-bg;
  box-sizing: border-box;

  a {
    display: block;
    width: 100px;
    margin-top: 8px;
  }

  .router-link-active {
    color: var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
  }
}

.navClose {
  background: -webkit-linear-gradient(left, #fff 50%, #eef2f5);
  width: 54px;

  a {
    width: 20px;
  }

  .router-link-active {
    border-bottom: 0;
  }
}

.btnExpand {
  border: none;
  background: none;
  transition: all 0.5s;
  font-size: 14px;
  color: #495060;
  padding: 15px;
}

.link {
  text-decoration: none;
  font-size: 13px;
  margin: 0 20px;
  color: #7d7d7d;
  line-height: 32px;
  height: 32px;
  cursor: pointer;
  display: inline-block;

  .listName {
    margin-left: 15px;
    transition: margin-left 0.8s;
  }

  .listNameClose {
    margin-left: 50px;
  }
}

@media (min-width: 1600px) {
  .link {
    font-size: 16px;
    line-height: 40px;
    height: 40px;
  }

  .navName {
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
}

.active-link {
  background-color: #e8f0f9;
  /* Light blue background instead of yellow */
  color: #3a6ea5;
  /* Blue text color */
  border-radius: 10px;
}
</style>
